module.exports = __webpack_public_path__ + "img/login-figure.10327ec0.png";